'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _createi18n = require('./createi18n');

var _createi18n2 = _interopRequireDefault(_createi18n);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

exports.i18n = _i18n2['default'];
exports.createi18n = _createi18n2['default'];
exports.user = _user2['default'];


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/react-i18n/dist/index.js
// module id = 469
// module chunks = 0